export default defineNuxtPlugin({
  name: 'strapi-user-hydrate',
  enforce: 'pre',
  async setup () {
    // /live не тягне профіль: там немає ні коментарів, ні приватних аніме,
    // а все потрібне про глядача (чи є твіч-саб / Монобаза) приходить одним
    // запитом /live-setting/access. Другий похід у Strapi був би зайвим
    if (useRequestURL().pathname.startsWith('/live')) return

    await hydrateStrapiUser()
  }
})
